import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, Tooltip, useTheme } from "@mui/material";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
export function SMILESComponent({ smiles, handleLoadSMILES, invalid, }) {
    const theme = useTheme();
    return (_jsxs(Box, Object.assign({ component: "span", sx: {
            display: "inline-flex",
            justifyContent: "flex-start",
            alignItems: "center",
            px: 1,
            m: 1,
            bgcolor: "#404040",
            color: "grey.300",
            border: "1px solid",
            borderColor: "grey.800",
            borderRadius: 2,
            fontSize: "0.875rem",
            fontWeight: "700",
        } }, { children: [_jsx(Box, { children: smiles }), invalid ? (_jsx(Tooltip, Object.assign({ title: "Invalid SMILES", arrow: true }, { children: _jsx(Box, Object.assign({ sx: {
                        p: "5px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    } }, { children: _jsx(ErrorOutlineIcon, { fontSize: "small", sx: { color: theme.palette.error.light } }) })) }))) : (_jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Load to viewer", baseColor: theme.palette.primary.light, onClick: () => handleLoadSMILES(smiles), colorOnHover: true }, { children: _jsx(AddCircleOutlineIcon, { fontSize: "small" }) })))] })));
}
